<nav>
  <h3>Table of Contents</h3>
  <div class="sections scrollbar">
    <ng-container *ngFor="let section of sections">
      <ul *ngIf="section.title">
        <li class="section">
          <div class="section-header">
            <div class="section-header-content">
              <a [attr.href]="createAnchorHref(section.title)"
                [class.disabled]="allSubSectionsDisabled(section)"
                (click)="onClick($event, section.title)">
                {{ section.title }}
              </a>
            </div>
            <em
              *ngIf="hasSubsections(section)"
              class="icon icon-down_small"
              [class.expanded]="section.expanded"
              (click)="section.expanded = !section.expanded"
            ></em>
          </div>
            <!-- Subsections dropdown -->
            <ul *ngIf="hasSubsections(section) && section.expanded" class="subsections">
              <ng-container *ngFor="let subsection of section.subsections">
                <li class="subsection" *ngIf="subsection.title">
                  <a [attr.href]="createAnchorHref(subsection.title)"
                    [class.disabled]="hasNoContent(subsection)"
                    (click)="onClick($event, subsection.title)">
                    {{ subsection.title }}
                  </a>
                </li>
              </ng-container>
            </ul>
        </li>
      </ul>
    </ng-container>
  </div>
</nav>
